<ion-app class="brand">
  <ion-menu menuId="main-menu" contentId="content1" side="start" [swipeGesture]="false">
    <ion-content>
      <app-sidemenu></app-sidemenu>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="content1" main></ion-router-outlet>
</ion-app>